import React, { useState } from 'react';
// "styled-components": "^5.2.1",
// import styled from "styled-components";
import { connect, useSelector, useDispatch } from 'react-redux';

import { Factor, AddFactor } from '../Factor'
// import collectionApi from 'src/api/v2/CollectionApi'
import { createNewDraftFactor } from 'src/util/PrioritizeUtil'
import { FactorInterface } from './models'
import { DragContainer } from 'src/components/shared'
import { createQuestions, updateQuestion, deleteQuestion } from 'src/actions/prioritize'

const DefaultWrapper = ({ children }) => {
  return (<> {children} </>)
}

const FactorGrid = ({
  // factors = [],
  collection,
  parentId: propParentId,
  editable = true,
  Wrapper = DefaultWrapper,
  source,
  createQuestions,
  updateQuestion,
  deleteQuestion
}: {
  // factors: FactorInterface[],
  collection: any,
  parentId?: string,
  editable?: boolean,
  Wrapper?: (children: any) => any,
  source: 'current' | 'template',
  createQuestions: any,
  updateQuestion: any,
  deleteQuestion: any,
}) => {
  const parentId = propParentId ? propParentId : (collection && collection.id)
  const isTemplate = source === 'template'

  const sourceActionType = `SET_${source.toLocaleUpperCase()}_FACTORS`

  const sourceAttr = source + 'Factors'
  const sourceFactors = useSelector((state) => state.prioritize[sourceAttr]) || []
  const setSourceFactors = useDispatch()

  const [unsavedFactors, setUnsavedFactors] = useState([])

  const formatQuestion = (factor) => {
    const sort_order = sourceFactors.findIndex(f => f.id === factor.id)
    const question = factor.sort_order ? factor : { ...factor, sort_order }
    return question
  }

  const onFactorSave = async (factor: FactorInterface) => {
    if (!factor) {
      console.error('Something wrong', factor);
      return
    }
    // const newCurrentFactors = await updAndGetFactors(sourceFactors, factor, collection.id)
    if (factor.is_draft) {
      createQuestions({ parentId, questions: [{ ...factor, sort_order: sourceFactors.length }], isTemplate })
    } else {
      // Remove when sort_order will be sent from backend
      const question = formatQuestion(factor)
      updateQuestion({ parentId, question, isTemplate })
    }

    setUnsavedFactors([...unsavedFactors.filter((id) => id !== factor.id)])
    // setSourceFactors({ type: sourceActionType, payload: newCurrentFactors });
  }

  const onFactorDelete = (deletedFactor: FactorInterface) => () => {
    const factorsWithoutDeleted = [...sourceFactors].filter((factor) => factor.id !== deletedFactor.id)

    if (!deletedFactor.is_draft)
      deleteQuestion({ parentId, deleteQuestionId: deletedFactor.id, isTemplate })

    setSourceFactors({ type: sourceActionType, payload: factorsWithoutDeleted })
  }

  const onFactorAdd = () => {
    const factorsWithNewFactor = sourceFactors ? [...sourceFactors] : [];
    const newDraftFactor = createNewDraftFactor();

    factorsWithNewFactor.push(newDraftFactor);
    setSourceFactors({ type: sourceActionType, payload: factorsWithNewFactor })
  }

  const onFactorEdit = (factorId: string) => () => {
    setUnsavedFactors([...unsavedFactors, factorId])
  }

  const onFactorDrag = (payload) => {
    setSourceFactors({ payload, type: sourceActionType })
  }

  const onFactorDrop = () => {
    sourceFactors.map((q, i) => updateQuestion({ parentId, question: ({ ...q, sort_order: i }), isTemplate }))
  }

  if (editable) {
    return (
      <div className="factors_container" >
        <DragContainer
          itemList={sourceFactors}
          appendChildren={<div><AddFactor onClick={onFactorAdd} /></div>}
          setItemList={onFactorDrag}
          dropItem={onFactorDrop}
          render={(factorInfo) => (
            <Wrapper>
              <Factor
                key={factorInfo.id}
                factor={factorInfo}
                editable={editable}
                onSave={onFactorSave}
                onDelete={onFactorDelete(factorInfo)}
                onEdit={onFactorEdit(factorInfo.id)}
              />
            </Wrapper>
          )}
        />
      </div>
    )
  } else {
    return (
      <div className="factors_container">
        {
          sourceFactors.map((factorInfo) => (
            <Factor
              key={factorInfo.id}
              factor={factorInfo}
              editable={editable}
              onSave={onFactorSave}
              onDelete={onFactorDelete(factorInfo)}
              onEdit={onFactorEdit(factorInfo.id)}
            />
          ))
        }
      </div>
    )
  }

}


const mapStateToProps = ({ prioritize }) => ({
  collection: prioritize.collection,
})

export default connect(mapStateToProps, {
  createQuestions,
  updateQuestion,
  deleteQuestion
})(FactorGrid)


